export default "__VITE_ASSET__BU6axj72__"